import React from 'react';
import classNames from 'classnames';

type EntityDetailsContentBodyProps = {
  children: React.ReactNode;
  entityId: string;
  hideBorder?: boolean;
};

export default function EntityDetailsContentBody({
  children,
  entityId,
  hideBorder = false,
}: EntityDetailsContentBodyProps) {
  return (
    <div
      className={classNames(
        {
          'border-t border-grey-300': !hideBorder,
        },
        'pt-5',
      )}
      {...(entityId && {
        'data-testid': `entity-details-content-${entityId}`,
      })}
    >
      {children}
    </div>
  );
}
